import styled from 'styled-components';
import { Layout as AntLayout } from 'antd';

export const Layout = styled(AntLayout)`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

export const Logo = styled.img`
  margin: 0 auto;
  margin-bottom: 25px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.25rem;
`;
